/**
 * Transforms a string from UPPER_SNAKE_CASE to kebab-case
 * @param str - The string in upper snake case to transform (e.g., 'SOME_EXAMPLE')
 * @returns The transformed string in kebab-case (e.g., 'some-example')
 */
export const fromUpperToKebabCase = (str: string): string => {
  return str.toLowerCase().replace(/_/g, '-');
};
